export const lists = (intl) => [
  {
    duration: 'days',
    value: 0,
    flag: true,
    label: intl.formatMessage({ id: 'Admin.Log.Viewer.today' }),
  },
  {
    duration: 'minutes',
    value: 15,
  },
  {
    duration: 'minutes',
    value: 30,
  },
  {
    duration: 'hours',
    value: 1,
  },
  {
    duration: 'hours',
    value: 24,
  },
  {
    duration: 'days',
    value: 7,
  },
];

export const defaultDateTimeQuery = (intl) => lists(intl)[1];

const services = [
  { name: 'ECM', value: 'ecm' },
  { name: 'Jobs', value: 'ecm-worker' },
  { name: 'Request', value: 'arsms' },
  { name: 'User', value: 'userms' },
  { name: 'Identity warehouse', value: 'idwms' },
  { name: 'Restart', value: 'bouncer' },
  { name: 'Gateway', value: 'gateway' },
  { name: 'Connector', value: 'connectorms' },
  { name: 'Windows Connector', value: 'windows-connectorms' },
  { name: 'External', value: 'externalms' },
  { name: 'Notification', value: 'notificationms' },
  { name: 'Rule & Role Recommendations', value: 'intelligencerulejob' },
  { name: 'Intelligence MS', value: 'intelligencems' },
  { name: 'Identity Service', value: 'authms' },
  { name: 'Identity Federation', value: 'keycloak' },
  { name: 'Native Connector', value: 'adsi' },
  { name: 'Channel', value: 'channelms' },
  { name: 'Orchestration', value: 'o12ms' },
  { name: 'Orchestration Worker', value: 'o12workerms' },
  { name: 'Integration Agent', value: 'cua-agent' },
  { name: 'Integration Import Service', value: 'import-worker-service' },
  { name: 'Integration Provisioning Service', value: 'provision-worker-service' },
];

export const serviceNamesMapping = (
  isPAMServicesEnabled = false,
  isTaskRunnerMSEnabled = false,
  isJitForAppsEnabled = false,
  isCertMSEnabled = false
) => {
  if (isTaskRunnerMSEnabled && !services.some((cred) => cred.name === 'Custom Extensions')) {
    services.push({ name: 'Custom Extensions', value: 'taskrunnerms' });
  }

  const newServices = [...services];

  if (isPAMServicesEnabled || isJitForAppsEnabled) {
    newServices.push({ name: 'PAM', value: 'pamms' });
  }

  if (isPAMServicesEnabled) {
    newServices.push({ name: 'RDP gateway', value: 'rdp-gateway' });
    newServices.push({ name: 'SSH gateway', value: 'ssh-gateway' });
    newServices.push({ name: 'SSH Proxy', value: 'pam-ssh-proxy' });
  }

  if (isCertMSEnabled) {
    newServices.push({ name: 'Certifications', value: 'certms' });
  }

  return newServices;
};

export const sequentialLogsDuration = 60;
export const noServicesSelected = 'none';
